export default "<router-outlet></router-outlet>\n<app-loader image=\"/spinner.gif\"></app-loader>";